import { render, staticRenderFns } from "./NewEvent.vue?vue&type=template&id=43afeac6"
import script from "./NewEvent.vue?vue&type=script&lang=js"
export * from "./NewEvent.vue?vue&type=script&lang=js"
import style0 from "./NewEvent.vue?vue&type=style&index=0&id=43afeac6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports